import { TOKENS } from 'tools/utils/constants';
import { useQuery } from '@tanstack/react-query';

// const COIN_PRICE_PROXY = "/api/coin-price";
const COIN_PRICE_PROXY = 'https://coin-prices-lyart.vercel.app';


const SUPPORTED_ADDRESSES = new Set(TOKENS.map((token) => token.address.toLowerCase()));

export function isPriceApiSupported(address: string | undefined): boolean {
  return Boolean(address) && SUPPORTED_ADDRESSES.has(address!.toLowerCase());
}

export interface TokenPriceData {
  name: string;
  symbol: string;
  current_price: number | null;
  market_cap_rank: number | null;
  last_updated: string | null;
  image: {
    thumb?: string;
    small?: string;
    large?: string;
  } | null;
  total_supply: number | null;
  max_supply: number | null;
  circulating_supply: number | null;
  market_cap: number | null;
  fully_diluted_valuation: number | null;
  total_volume: number | null;
  high_24h: number | null;
  low_24h: number | null;
  price_change_24h: number | null;
  price_change_percentage_24h: number | null;
  market_cap_change_24h: number | null;
  market_cap_change_percentage_24h: number | null;
  ath: number | null;
  ath_date: string | null;
  atl: number | null;
  atl_date: string | null;
  genesis_date: string | null;
  links: TokenLinks | null;
}

export interface TokenLinks {
  homepage: Array<string>;
  whitepaper?: string;
  blockchain_site?: Array<string>;
  official_forum_url?: Array<string>;
  chat_url?: Array<string>;
  announcement_url?: Array<string>;
  twitter_screen_name?: string;
  facebook_username?: string;
  telegram_channel_identifier?: string;
  subreddit_url?: string;
  repos_url?: {
    github?: Array<string>;
    bitbucket?: Array<string>;
  };
}

export function tokenPriceQueryOptions(address: string | undefined) {
  return {
    queryKey: ['token-price-data', address?.toLowerCase()],
    enabled: isPriceApiSupported(address),
    staleTime: 60 * 1000,
    retry: false,
    queryFn: async () => {
      const response = await fetch(`${COIN_PRICE_PROXY}/api/coins/${address}`);

      if (!response.ok) {
        throw new Error(`Coin price request failed with status ${response.status}`);
      }

      return response.json() as Promise<TokenPriceData>;
    },
  };
}

export default function useTokenPriceData(address: string | undefined) {
  return useQuery(tokenPriceQueryOptions(address));
}
